// extracted by mini-css-extract-plugin
export default {"submitBtn":"gR8dNhOHytFa5dzme2oV"};